const state = {
  toolsList: [],
  typeToolsList: [],
  manageTool: null,
  manageTypeTool: null
}

export default state
